import React from 'react';
import queryString from 'query-string';
import PrivateRoute from 'PrivateRoutes';
import { Holiday } from './components';

const HolidayList = ({ location }) => {
  const queryParams = queryString.parse(location.search);
  console.log('queryParams', queryParams);
  return <Holiday HolidayId={queryParams.id} />;
};
const routes = () => (
  <PrivateRoute exact path="/settings/Holiday" component={HolidayList} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Holiday/routes.js